export const types = {
  SET_USER_DATA: "SET_USER_DATA",
  GET_DISCOVER_MOVIES: "GET_DISCOVER_MOVIES",
  GET_HORROR_MOVIES: "GET_HORROR_MOVIES",
  GET_ANIMATION_MOVIES: "GET_ANIMATION_MOVIES",
  GET_COMEDY_MOVIES: "GET_COMEDY_MOVIES",
  GET_ACTION_MOVIES: "GET_ACTION_MOVIES",
};

export const movieDetailsTypes = {
  SET_DATA_TO_STATE: "SET_DATA_TO_STATE",
  SET_CAST_TO_STATE: "SET_CAST_TO_STATE",
};

export const trailerTypes = {
  SET_TRAILER: "SET_TRAILER",
};
